import React, {useState, useEffect} from 'react'
import {Button, Form, Accordion, Icon} from 'semantic-ui-react'
import API from '../../../api'
import Dialog from '../../dialog'
import {getApiResponseErrorMessage} from '../../error'
import {statusOptions, fieldNames} from '../options'
import * as Yup from 'yup'
import useSWR  from 'swr'
import {GlossaryFetcher} from "../../../fetch/glossary"
import {AppFetcher} from "../../../fetch/application"
import styles from '../styles.module.scss'

export const ElementList = ({content, onDragStart}) => {
    const [elements, setElements] = useState([]);
    const { data : contentDetails, errorContent } = useSWR(content && content.id ? `/endpoint/data-content/details/${content.id}` : null, AppFetcher, { errorRetryCount: 2 })

    React.useEffect(() => {
        if(contentDetails && contentDetails.data) {
            setElements(contentDetails.data)
        }
        if(content === null) {
            setElements([])
        }
    }, [content, contentDetails])

    return (<div>
        {/*<hr />
        <div className={styles.margin10}><b>Elements</b></div>*/}
        {elements && elements.dataElements && elements.dataElements.map((element, i) => {
            return <div
                key={i}
                className={styles.element}
                content={element}
                onDragStart = {(e)=>onDragStart(e, element, content)}
                draggable
                title={"Drag to Attribute to connect"}
            >
                {element.name}
            </div>
        })}
    </div>)
}

const AddDialog = ({ title, open, onSubmit, onClose, item }) => {

    const initialState = {
        loading: false,
        id: null,
        //description: '',
        status: '',
        selectedReport: null,
        report: {
            name: '',
            status: '',
            definition: ''
        },
        schedule: {
            name: '',
            status: '',
            definition: ''
        },
        attributes: [{
            name: '',
            status: '',
            definition: ''
        }],
    }

    const [state, setState] = useState(initialState)
    const [errors, setError] = useState({})

    const { data : details, errorAppDetails } = useSWR(item && item.id ? `/endpoint/details/${item.id}` : null, GlossaryFetcher, { errorRetryCount: 2 })
    const { data : reports, errorReports } = useSWR((!open || item) ? null : `/endpoint/report/list`, GlossaryFetcher, { errorRetryCount: 2 })
    const { data : contentList, errorContent } = useSWR(item && item.schedule && item.schedule.id ? `/endpoint/data-content/list/${item.schedule.id}` : null, AppFetcher, { errorRetryCount: 2 })

    React.useEffect(() => {

        if(details && details.data) {
            //console.log("details", details.data)
            setState(state => {
                return {
                    ...state,
                    id: details.data.id,
                    //description: details.data.description ? details.data.description : "",
                    status: details.data.status,
                    report: {
                        id: details.data.report.id,
                        name: details.data.report.name,
                        status: details.data.report.status,
                        definition: details.data.report.definition
                    },
                    schedule: {
                        id: details.data.schedule.id,
                        name: details.data.schedule.name,
                        status: details.data.schedule.status,
                        definition: details.data.schedule.definition
                    },
                    attributes: details.data.attributes.length > 0 ? details.data.attributes : initialState.attributes
                }
            })
        }

    }, [details])

    const [reportList, setReportList] = useState([])
    React.useEffect(() => {

        let list = [];

        if(reports && reports.data) {
            reports.data.map((rep, i) => {
                list.push({
                    text: rep.name,
                    value: rep.id
                })
            })
            setReportList(list)

        }

    }, [reports])

    const onDragStart = (e, element, content) => {
        e.dataTransfer.setData("element", element.dataContentDetailId);
        e.dataTransfer.setData("elementName", element.name);
        e.dataTransfer.setData("contentName", content.name);
    }

    const onDrop = (e, attribute, i) => {
        e.preventDefault();
        let elem = e.dataTransfer.getData("element");
        let elemName = e.dataTransfer.getData("elementName");
        let contName = e.dataTransfer.getData("contentName");


        const _tmpA = state.attributes
        if(_tmpA[i].id === attribute.id) {
            _tmpA[i].dataContentDetailId = Number(elem);
            _tmpA[i].dataContentDetailName = elemName;
            _tmpA[i].dataContentContentName = contName;
        }
        setState( state => {
            return {
                ...state,
                attributes: _tmpA
            }
        })
    }

    const onDragOver = (e )=> {
        e.preventDefault();
        e.dataTransfer.dropEffect = "copy";
    }

    const formSchema = Yup.object().shape({
        status: Yup.string()
            .required(),
        report: Yup.object({
            name: Yup.string()
                .max(255, 'Must be max 255 characters')
                .required(),
            definition: Yup.string()
                .max(2000, 'Must be max 2000 characters')
                .required(),
            status: Yup.string()
                .required()}),
        schedule: Yup.object({
            name: Yup.string()
                .max(255, 'Must be max 255 characters')
                .required(),
            definition: Yup.string()
                .max(2000, 'Must be max 2000 characters')
                .required(),
            status: Yup.string()
                .required()})
    });

    const handleInputChange = (e, {index, name, value}) => {
        const _tmp_name = name.split("_")
        const name_group = _tmp_name[0]
        const name_sub = _tmp_name[1]

        if(name_sub !== "" && name_group === "report") {

            setState( state => {
                return {
                    ...state,
                    report: {
                        ...state.report,
                        [name_sub]: value
                    }
                }
            })
        }

        else if(name_sub !== "" && name_group === "schedule") {

            setState( state => {
                return {
                    ...state,
                    schedule: {
                        ...state.schedule,
                        [name_sub]: value
                    }
                }
            })
        }

        else if(name_sub !== "" && name_group === "attribute") {

            let _tmp = state.attributes;
            const setAt = at => {
                return {
                    ...at,
                    [name_sub]: value
                }
            }
            _tmp[index] = setAt(state.attributes[index])

            setState( state => {
                return {
                    ...state,
                    attributes: _tmp
                }
            })
        }

        else {

            setState( state => {
                return {
                    ...state,
                    [name]: value
                }
            })
        }

        if (errors[name]) {
            setError( errors => {
                return {
                    ...errors,
                    [name]: false
                }
            })
        }
    }

    const setExistingReport = (e, {value}) => {
        if(value) {
            const _report = reports.data.filter(r => r.id === value)[0]
            setState(state => {
                return {
                    ...state,
                    selectedReport: value,
                    report: {
                        id: _report.id,
                        name: _report.name,
                        status: _report.status,
                        definition: _report.definition,
                    }
                }
            })
        }
        else {
            setState(state => {
                return {
                    ...state,
                    selectedReport: null,
                    report: {
                        name: '',
                        status: '',
                        definition: ''
                    }
                }
            })
        }
    }

    const addAttribute = () => {
        const _tmp = state.attributes
        _tmp.push({
            name: '',
            status: '',
            definition: ''
        })
        setState( state => {
            return {
                ...state,
                attributes: _tmp
            }
        })
    }

    const handleCallback = (callback, data) => {

        setState(initialState)
        setError({})
        handleDC(null) //reset Data Elements on dialog close


        if (Array.isArray(callback)) {
            callback.forEach( func => {
                if (typeof func === 'function') {
                    func(data)
                }
            })
        } else {
            if (typeof callback === 'function') {
                callback(data)
            }
        }

    }

    const handleOnSubmit = () => {

        setError({})

        let tmp_state = state

        if(tmp_state.attributes && tmp_state.attributes.length > 0) {
            const tmpA = tmp_state.attributes.filter((attr) => (attr.name !== "" || attr.definition !== "" || attr.status !== ""))
            delete tmp_state.attributes;
            tmp_state.attributes = tmpA
        }

        formSchema.validate(tmp_state, {abortEarly: false}).then(() => {

            setState( tmp_state => {
                return {
                    ...state,
                    loading: true
                }
            })

            //console.log(JSON.stringify(state))
            API.post('/endpoint/save', tmp_state)
                .then( response => handleCallback([onSubmit, onClose], response.data))
                .catch( err => {

                    setState( state => {
                        return {
                            ...state,
                            loading: false
                        }
                    })

                    //if(err.response) console.log(err.response)
                    if (err.response && err.response.data.messages) {

                        const errorFields = {}

                        for (const [key, value] of Object.entries(err.response.data.messages)) {
                            if(key.includes("attribute")) {
                                let i = Number(key.split("_")[0].split("attribute")[1]) - 1;
                                let _tmp_key = "attribute_" + key.split("_")[1] + i
                                let _tmp_field = "attribute_" + key.split("_")[1]
                                errorFields[_tmp_key] = getApiResponseErrorMessage({key: value, prefix: fieldNames[_tmp_field]})
                            }
                            else {
                                errorFields[key] = getApiResponseErrorMessage({key: value, prefix: fieldNames[key]})
                            }
                        }

                        setError( err => {
                            return {
                                ...err,
                                ...errorFields
                            }
                        })

                    }

                })

        }).catch( errors => {

            console.log(errors)

            const errorFields = {}

            errors.inner.forEach( error => {
                let _tmp = error.path.split(".")
                let tmp = error.path
                if(_tmp[1] !== undefined) {
                    tmp = _tmp[0] + "_" + _tmp[1]
                }
                errorFields[tmp] = error.message.replace(error.path, fieldNames[tmp])
            } )

            setError( err => {
                return {
                    ...err,
                    ...errorFields
                }
            })

        })

    }

    const [showDCvalue, setShowDCValue] = useState(null)
    const handleDC = (content) => {
        setShowDCValue(content)
    }
    const [activeIndex, setActiveIndex] = useState(-1)
    const handleAccordion = (e, titleProps) => {
        const { index } = titleProps
        const newIndex = activeIndex === index ? -1 : index
        setActiveIndex(newIndex)
    }

    React.useEffect(() => {
        setActiveIndex(-1)
    }, [item])

    return (
        <Dialog open={open} onClose={() => handleCallback(onClose)}  closeOnEscape={false} closeOnDimmerClick={false}>

            <Form onSubmit={handleOnSubmit} loading={state.loading} style={{border: (Object.keys(errors).length !== 0) ? "4px solid #9F3A39" : "none"}}>

                <Dialog.Header>
                    {item && item.id ? "Edit endpoint" : title}
                </Dialog.Header>

                <Dialog.Content>

                    {item && item.id ? //in edit showing report fields(edit of report already added to this endpoint), for new showing all adding report options
                        <>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <Accordion className={styles.accordion}>
                                    <Accordion.Title
                                        active={activeIndex === 0}
                                        index={0}
                                        onClick={handleAccordion}
                                        className={styles.title}
                                    >
                                        <Icon name='chevron down'/>
                                        REPORT: <b>{state.report.name}</b> <br />
                                    </Accordion.Title>
                                    <Accordion.Content active={activeIndex === 0} className={styles.accordionContent}>
                                        <Form.Input
                                            name="report_name"
                                            label={fieldNames.report_name}
                                            error={errors.report_name}
                                            onChange={handleInputChange}
                                            value={state.report.name}
                                        />

                                        <br/>

                                        <Form.Select
                                            name="report_status"
                                            label={fieldNames.report_status}
                                            options={statusOptions}
                                            error={errors.report_status}
                                            placeholder={"Select Status"}
                                            value={state.report.status}
                                            onChange={handleInputChange}
                                            icon={"chevron down"}
                                        />

                                        <br/>

                                        <Form.Input
                                            name="report_definition"
                                            label={fieldNames.report_definition}
                                            onChange={handleInputChange}
                                            error={errors.report_definition}
                                            value={state.report.definition}
                                        />
                                    </Accordion.Content>
                                </Accordion>
                                <br />
                                <Form.Select
                                    name="status"
                                    label={fieldNames.status}
                                    options={statusOptions}
                                    error={errors.status}
                                    placeholder={"Select Status"}
                                    value={state.status}
                                    onChange={handleInputChange}
                                    icon={"chevron down"}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Accordion className={styles.accordion}>
                                    <Accordion.Title
                                        active={activeIndex === 1}
                                        index={1}
                                        onClick={handleAccordion}
                                        className={styles.title}
                                    >
                                        <Icon name='chevron down'/>
                                        SCHEDULE: <b>{state.schedule.name}</b> <br />
                                    </Accordion.Title>
                                    <Accordion.Content active={activeIndex === 1} className={styles.accordionContent}>
                                        <Form.Input
                                            name="schedule_name"
                                            label={fieldNames.schedule_name}
                                            onChange={handleInputChange}
                                            error={errors.schedule_name}
                                            value={state.schedule.name}
                                        />

                                        <br />

                                        <Form.Select
                                            name="schedule_status"
                                            label={fieldNames.schedule_status}
                                            options={statusOptions}
                                            error={errors.schedule_status}
                                            placeholder={"Select Status"}
                                            value={state.schedule.status}
                                            onChange={handleInputChange}
                                            icon={"chevron down"}
                                        />

                                        <br />

                                        <Form.Input
                                            name="schedule_definition"
                                            label={fieldNames.schedule_definition}
                                            error={errors.schedule_definition}
                                            onChange={handleInputChange}
                                            value={state.schedule.definition}
                                        />
                                    </Accordion.Content>
                                </Accordion>
                            </Form.Field>
                        </Form.Group>
                        <hr style={{margin: "20px 0"}} />
                        <Form.Group widths="equal">
                            <Form.Field>
                                <span>ATTRIBUTES:</span>
                                    {state.attributes.map((attr, i) => {
                                        return <Accordion
                                            key = {i}
                                            onDragOver={(e)=>onDragOver(e)}
                                            onDrop={(e)=>onDrop(e, attr, i)}
                                        >
                                            <Accordion.Title
                                                active={activeIndex === i+10}
                                                index={i+10}
                                                onClick={handleAccordion}
                                                style={{paddingTop: "12px"}}
                                            >
                                                {attr.name ? <b>{attr.name}</b> : <span className={styles.tip}>(New attribute)</span>}
                                                <Icon name='chevron down' className={styles.smallIcon}/>
                                            </Accordion.Title>
                                            <Accordion.Content active={activeIndex === i+10} className={styles.accordionContent}>

                                                <div className={styles.marginB10}>
                                                    <span className={styles.label}>Element: </span><br />
                                                    {attr.dataContentDetailName
                                                        ? <span className={styles.elName}>{attr.dataContentContentName}: {attr.dataContentDetailName} </span>
                                                        : (attr.dataContent && attr.dataElement && attr.dataElement.name)
                                                            ? <span className={styles.elName}>{attr.dataContent.name}: {attr.dataElement.name} </span>
                                                            : <span className={styles.tip}>(Drag Data Element here)</span>
                                                    }
                                                </div>
                                                <Form.Input
                                                    name={"attribute_name"}
                                                    label={fieldNames.attribute_name}
                                                    onChange={handleInputChange}
                                                    error={errors['attribute_name'+i]}
                                                    index={i}
                                                    value={attr.name}
                                                />

                                                <br />

                                                <Form.Select
                                                    name={"attribute_status"}
                                                    label={fieldNames.attribute_status}
                                                    options={statusOptions}
                                                    error={errors['attribute_status'+i]}
                                                    placeholder={"Select Status"}
                                                    value={attr.status}
                                                    index={i}
                                                    onChange={handleInputChange}
                                                    icon={"chevron down"}
                                                />

                                                <br />

                                                <Form.Input
                                                    name={"attribute_definition"}
                                                    label={fieldNames.attribute_definition}
                                                    error={errors['attribute_definition'+i]}
                                                    index={i}
                                                    onChange={handleInputChange}
                                                    value={attr.definition}
                                                />
                                            </Accordion.Content>
                                        </Accordion>
                                    })}
                                        <Icon name="plus" title={"Add new Attribute"} onClick={addAttribute} className={styles.plusIcon}/>

                            </Form.Field>
                            <Form.Field>

                                {contentList && contentList.data && <div> <span className={styles.margin10}>DATA CONTENTS:</span>
                                    {contentList.data.map((content,i) => {
                                        return <div
                                            key={i}
                                            onClick={() => handleDC(content)}
                                            style={{cursor: "pointer", margin: "10px"}}
                                        >{content.name}<Icon name={"chevron down"}  className={styles.smallIcon}/>
                                            {(showDCvalue === content) && <ElementList content={showDCvalue} onDragStart={onDragStart}/>}
                                        </div>
                                    })
                                    }
                                </div>
                                }

                            </Form.Field>

                        </Form.Group>
                        </>
                        :
                        <>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <span>REPORT</span> <br /><br />
                                    {reportList && <Form.Select
                                        name={"reports"}
                                        label={"Existing reports"}
                                        options={reportList}
                                        clearable={true}
                                        placeholder={"Select Report or add a new one"}
                                        onChange={setExistingReport}
                                        value={state.selectedReport}
                                        icon={"chevron down"}
                                    />}
                                    <br/>

                                    {!state.selectedReport && <>
                                        <Form.Input
                                            name="report_name"
                                            label={fieldNames.report_name}
                                            error={errors.report_name}
                                            onChange={handleInputChange}
                                            value={state.report.name}
                                        />

                                        <br/>

                                        <Form.Select
                                            name="report_status"
                                            label={fieldNames.report_status}
                                            options={statusOptions}
                                            error={errors.report_status}
                                            placeholder={"Select Status"}
                                            value={state.report.status}
                                            onChange={handleInputChange}
                                            icon={"chevron down"}
                                        />

                                        <br/>

                                        <Form.Input
                                            name="report_definition"
                                            label={fieldNames.report_definition}
                                            onChange={handleInputChange}
                                            error={errors.report_definition}
                                            value={state.report.definition}
                                        />
                                    </>}
                                </Form.Field>
                                <Form.Field>
                                    <span>SCHEDULE</span> <br /><br />
                                    <Form.Input
                                        name="schedule_name"
                                        label={fieldNames.schedule_name}
                                        onChange={handleInputChange}
                                        error={errors.schedule_name}
                                        value={state.schedule.name}
                                    />

                                    <br />

                                    <Form.Select
                                        name="schedule_status"
                                        label={fieldNames.schedule_status}
                                        options={statusOptions}
                                        error={errors.schedule_status}
                                        placeholder={"Select Status"}
                                        value={state.schedule.status}
                                        onChange={handleInputChange}
                                        icon={"chevron down"}
                                    />

                                    <br />

                                    <Form.Input
                                        name="schedule_definition"
                                        label={fieldNames.schedule_definition}
                                        error={errors.schedule_definition}
                                        onChange={handleInputChange}
                                        value={state.schedule.definition}
                                    />
                                </Form.Field>
                            </Form.Group>
                            <hr style={{margin: "20px 0"}} />
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <Form.Select
                                        name="status"
                                        label={fieldNames.status}
                                        options={statusOptions}
                                        error={errors.status}
                                        placeholder={"Select Status"}
                                        value={state.status}
                                        onChange={handleInputChange}
                                        icon={"chevron down"}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    {/*<Accordion className={styles.accordion}>
                                        <Accordion.Title
                                            active={activeIndex === 2}
                                            index={2}
                                            onClick={handleAccordion}
                                            className={styles.title}
                                        >
                                            <Icon name='chevron down' />
                                            Attributes
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 2} className={styles.accordionContent}>
                                            {state.attributes.map((attr, i) => {
                                                return <div
                                                    key = {i}
                                                    className={styles.marginT10}
                                                    onDragOver={(e)=>onDragOver(e)}
                                                    onDrop={(e)=>onDrop(e, attr, i)}
                                                >

                                                    <div className={styles.marginB10}>
                                                        <span className={styles.label}>Element: </span><br />
                                                        {attr.dataContentDetailName
                                                            ? <span className={styles.elName}>{attr.dataContentContentName}: {attr.dataContentDetailName} </span>
                                                            : (attr.dataContent && attr.dataElement && attr.dataElement.name)
                                                                ? <span className={styles.elName}>{attr.dataContent.name}: {attr.dataElement.name} </span>
                                                                : <span className={styles.tip}>(Drag Data Element here)</span>
                                                        }
                                                    </div>
                                                    <Form.Input
                                                        name={"attribute_name"}
                                                        label={fieldNames.attribute_name}
                                                        onChange={handleInputChange}
                                                        error={errors['attribute_name'+i]}
                                                        index={i}
                                                        value={attr.name}
                                                    />

                                                    <br />

                                                    <Form.Select
                                                        name={"attribute_status"}
                                                        label={fieldNames.attribute_status}
                                                        options={statusOptions}
                                                        error={errors['attribute_status'+i]}
                                                        placeholder={"Select Status"}
                                                        value={attr.status}
                                                        index={i}
                                                        onChange={handleInputChange}
                                                        icon={"chevron down"}
                                                    />

                                                    <br />

                                                    <Form.Input
                                                        name={"attribute_definition"}
                                                        label={fieldNames.attribute_definition}
                                                        error={errors['attribute_definition'+i]}
                                                        index={i}
                                                        onChange={handleInputChange}
                                                        value={attr.definition}
                                                    />
                                                    {i < (state.attributes.length - 1) ? <hr /> : ""}
                                                </div>
                                            })}
                                            <Icon name="plus" title={"Add new Attribute"} onClick={addAttribute} className={styles.plusIcon}/>
                                        </Accordion.Content>
                                    </Accordion>*/}
                                    <span>ATTRIBUTES:</span>
                                    {state.attributes.map((attr, i) => {
                                        return <Accordion
                                            key = {i}
                                            onDragOver={(e)=>onDragOver(e)}
                                            onDrop={(e)=>onDrop(e, attr, i)}
                                        >
                                            <Accordion.Title
                                                active={activeIndex === i+10}
                                                index={i+10}
                                                onClick={handleAccordion}
                                                style={{paddingTop: "12px"}}
                                            >
                                                {attr.name ? <b>{attr.name}</b> : <span className={styles.tip}>(New attribute)</span>}
                                                <Icon name='chevron down' className={styles.smallIcon}/>
                                            </Accordion.Title>
                                            <Accordion.Content active={activeIndex === i+10} className={styles.accordionContent}>

                                                <div className={styles.marginB10}>
                                                    <span className={styles.label}>Element: </span><br />
                                                    {attr.dataContentDetailName
                                                        ? <span className={styles.elName}>{attr.dataContentContentName}: {attr.dataContentDetailName} </span>
                                                        : (attr.dataContent && attr.dataElement && attr.dataElement.name)
                                                            ? <span className={styles.elName}>{attr.dataContent.name}: {attr.dataElement.name} </span>
                                                            : <span className={styles.tip}>(Drag Data Element here)</span>
                                                    }
                                                </div>
                                                <Form.Input
                                                    name={"attribute_name"}
                                                    label={fieldNames.attribute_name}
                                                    onChange={handleInputChange}
                                                    error={errors['attribute_name'+i]}
                                                    index={i}
                                                    value={attr.name}
                                                />

                                                <br />

                                                <Form.Select
                                                    name={"attribute_status"}
                                                    label={fieldNames.attribute_status}
                                                    options={statusOptions}
                                                    error={errors['attribute_status'+i]}
                                                    placeholder={"Select Status"}
                                                    value={attr.status}
                                                    index={i}
                                                    onChange={handleInputChange}
                                                    icon={"chevron down"}
                                                />

                                                <br />

                                                <Form.Input
                                                    name={"attribute_definition"}
                                                    label={fieldNames.attribute_definition}
                                                    error={errors['attribute_definition'+i]}
                                                    index={i}
                                                    onChange={handleInputChange}
                                                    value={attr.definition}
                                                />
                                            </Accordion.Content>
                                        </Accordion>
                                    })}
                                    <Icon name="plus" title={"Add new Attribute"} onClick={addAttribute} className={styles.plusIcon}/>

                                </Form.Field>
                            </Form.Group>
                        </>
                        }

                </Dialog.Content>

                <Dialog.Actions>
                    <Button type="submit" primary>
                        Submit
                    </Button>
                    <Button onClick={() => handleCallback(onClose)}>
                        Cancel
                    </Button>
                </Dialog.Actions>

            </Form>
        </Dialog>
    )
}

export default AddDialog